export default __webpack_public_path__ + "static/media/practice_video_icon.c6a35e55.svg";